import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import styled from "styled-components"
import {
  ReviewExport,
  SelectListWithLabel,
  ReportGenerationButtons
} from "../../components/custom-report"
import * as customReportApiActions from "../../state/actions/customReportApiActions"
import * as reportSelectionActions from "../../state/actions/reportSelectionActions"
import LocationSelection from "./LocationSelection"
import EmployeeDetailsSelection from "./EmployeeDetailsSelection"
import IncludeOption from "./IncludeOption"
import CustomReportSubmitModal from "./Modals/CustomReportSubmitModal"
import formatDataForReportSubmission from "../../utils/customReport-utils"
import { ReportSelectedOptionsShape } from "../../state/shapes/CustomReportShapes"

const ReportCard = styled.div`
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-top: none;
  padding-top: 1em;
  color: #455a64;
`
class ReportGeneration extends Component {
  state = {
    showSubmitModal: false,
  }

  onReportTypeChanged = (reportTypeSelected) => {
    const newReportType = parseInt(reportTypeSelected, 10)
    this.props.setReportType(newReportType)
  }

  onAppraisalLevelChanged = (appraisalLevelSelected) => {
    const appraisalLevelId = parseInt(appraisalLevelSelected, 10)
    this.props.setAppraisalLevelId(appraisalLevelId)
  }

  onReviewChanged = (newReviewId) => {
    const reviewId = parseInt(newReviewId, 10)
    this.props.setReviewId(reviewId)
    this.props.changeReview(reviewId)
  }

  onLeaversChanged = (e) => {
    this.props.setIncludeLeavers(e.target.checked)
  }

  onPerformanceChanged = (e) => {
    this.props.setIncludePerformance(e.target.checked)
  }

  submitHandler = () => {
    this.props.submitReport(
      formatDataForReportSubmission(this.props.reportSelection, this.props.cultureCode)
    )
    this.setState({ showSubmitModal: true })
  }

  closeSubmitModal = () => {
    this.props.resetReportSelection()
    this.setState({ showSubmitModal: false })
    this.props.switchTabs()
  }

  resetHandler = () => {
    this.props.resetReportSelection()
  }

  initialSelectionForReportType = {
    text: this.props.t("CustomReport.ReportTypes.SelectReportType"),
    id: -1,
    disabled: true
  }

  render() {
    const { reportOptions, reportSelection, t } = this.props

    return (
      <ReportCard>
        <div className="container">
          <p>{t("CustomReport.CreateReport.Intro")}</p>
          {reportOptions.reportTypes.length > 0 ? (
            <SelectListWithLabel
              label={`${t("CustomReport.ReportTypes.ReportTypeLabel")} *`}
              data={reportOptions.reportTypes}
              onChange={this.onReportTypeChanged}
              initialSelection={this.initialSelectionForReportType}
              selectedValue={reportSelection.reportTypeId}
              sortAlphabetically
            />
          ) : null}
          {reportSelection.reportTypeId === 0 ? (
            <Fragment>
              <ReviewExport
                reviews={reportOptions.reviews}
                appraisalLevels={reportOptions.appraisalLevels}
                onAppraisalLevelChanged={this.onAppraisalLevelChanged}
                onReviewChanged={this.onReviewChanged}
                reviewData={reportOptions.reviewData}
              />
            </Fragment>
          ) : null}
          {reportSelection.reportTypeId >= 0 ? (
            <Fragment>
              <IncludeOption
                checked={this.props.reportSelection.includeLeavers}
                onChangedEvent={this.onLeaversChanged}
                text={t("CustomReport.Common.IncludeLeavers")}
              />
              <LocationSelection />
              <EmployeeDetailsSelection />
            </Fragment>
          ) : null}
          {reportOptions.reportTypes.length > 0 && reportSelection.reportTypeId >= 0 ? (
            <ReportGenerationButtons
              submitEnabled={reportSelection.readyToSubmit}
              submitHandler={this.submitHandler}
              resetHandler={this.resetHandler}
            />
          ) : null}
        </div>
        {this.state.showSubmitModal ? (
          <CustomReportSubmitModal closePopup={this.closeSubmitModal} />
        ) : null}
      </ReportCard>
    )
  }
}
function mapStateToProps(state) {
  return {
    reportOptions: state.customReport,
    reportSelection: state.reportSelection,
    cultureCode: state.userDetail.culture
  }
}

function mapDispatchToProps(dispatch) {
  return {
    changeReview: reviewId => {
      dispatch(customReportApiActions.loadReviewData(reviewId))
    },
    resetReportSelection: () => {
      dispatch(reportSelectionActions.resetReportSelection())
      dispatch(customReportApiActions.resetReportSelection())
    },
    submitReport: data => {
      dispatch(customReportApiActions.submitReport(data))
    },
    setReportType: reportTypeId => {
      dispatch(reportSelectionActions.setReportType(reportTypeId))
    },
    setReviewId: reviewId => {
      dispatch(reportSelectionActions.setReviewId(reviewId))
    },
    setAppraisalLevelId: appraisalLevelId => {
      dispatch(reportSelectionActions.setAppraisalLevelId(appraisalLevelId))
    },
    setIncludeLeavers: includeOption => {
      dispatch(reportSelectionActions.setIncludeLeavers(includeOption))
    },
    setIncludePerformance: includePerformance => {
      dispatch(reportSelectionActions.setIncludePerformance(includePerformance))
    }
  }
}

ReportGeneration.propTypes = {
  t: PropTypes.func.isRequired,
  changeReview: PropTypes.func.isRequired,
  resetReportSelection: PropTypes.func.isRequired,
  submitReport: PropTypes.func.isRequired,
  setIncludeLeavers: PropTypes.func.isRequired,
  setIncludePerformance: PropTypes.func.isRequired,
  setAppraisalLevelId: PropTypes.func.isRequired,
  setReviewId: PropTypes.func.isRequired,
  setReportType: PropTypes.func.isRequired,
  switchTabs: PropTypes.func.isRequired,
  reportOptions: PropTypes.shape({
    reportTypes: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.number,
        label: PropTypes.string
      })
    )
  }).isRequired,
  reportSelection: PropTypes.shape(ReportSelectedOptionsShape).isRequired,
  cultureCode: PropTypes.string.isRequired
}

export default compose(translate(), connect(mapStateToProps, mapDispatchToProps))(ReportGeneration)



// WEBPACK FOOTER //
// ./src/components/custom-report/ReportGeneration.jsx